import React, { useState, useEffect } from "react";
import Select from "antd/lib/select";
import accoArrow from "../../../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import {
  getAllFilters,
  getAllShareFilters,
  getAllTemplateFilters,
  getCombinedDate,
  getCustomizedDate,
  getGlobalBrands,
  getTimeIntervalDate,
  getWidgetGraphObject,
  useQuery,
} from "../../../../../redux/constants";
import { useDispatch, useSelector } from "react-redux";
import { getPaneIndex } from "../../../../../redux/constants";
import isEqual from "react-fast-compare";
import moment from "moment";
import {
  setPageChart,
  setWidgetMakerGraphData,
  setWidgetMakerShareGraphData,
  setWidgetMakerSharePageGraphData,
} from "../../../../../redux/actions/WidgetMaker/WidgetAPI";
import { setEditTemplateWidget } from "../../../../../redux/actions/section/section";

const { Option } = Select;

const CategoryOption = ({
  section_index,
  widget_index,
  widgetData,
  template_widget,
}) => {
  let query = useQuery();
  const dispatch = useDispatch();
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const { Option } = Select;
  const authParams = useSelector((state) => state.Authentication.authParams);
  const panes = useSelector((state) => state.Tab1.panes);
  const activeKey = useSelector((state) => state.Tab1.activeKey);
  const Section = useSelector((state) => state.Section.addSection);
  let index = getPaneIndex(panes, activeKey);
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const sharedDuration = useSelector((state) => state.Share.sharedDuration);
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );

  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );

  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const filterData = useSelector((state) => state?.Filter?.filterPanelData);

  const handleChangeCategory = (
    value,
    widgetData,
    section_index,
    widget_index
  ) => {
    let pathName = window.location.pathname?.split("/")?.[1];
    if (pathName === "edit-dashboard" || pathName === "create-dashboard") {
      // edit and create
      let traceName;
      filterData?.map((d) => {
        if (d?.attribute === value) {
          traceName = d?.title;
        }
      });
      let updatedBreakdown = [
        {
          ...widgetData?.y_axes?.[0],
          attribute: value,
          trace_name: traceName,
        },
      ];

      if (widgetData) {
        let updatedSection = [...Section];
        if (section_index >= 0) {
          updatedSection[section_index].data[widget_index].y_axes =
            updatedBreakdown;
          if (widgetData?.persist_graphdata) {
            updatedSection[section_index].data[widget_index].persist_graphdata =
              null;
          }
          if (widgetData?.deep_dive_on) {
            updatedSection[section_index].data[widget_index].deep_dive_on =
              null;
          }
          if (widgetData?.graphData) {
            updatedSection[section_index].data[widget_index].graphData = null;
          }
        } else {
          updatedSection[0].data[widget_index].y_axes = updatedBreakdown;
          if (widgetData?.persist_graphdata) {
            updatedSection[0].data[widget_index].persist_graphdata = null;
          }
          if (widgetData?.deep_dive_on) {
            updatedSection[0].data[widget_index].deep_dive_on = null;
          }
          if (widgetData?.graphData) {
            updatedSection[0].data[widget_index].graphData = null;
          }
        }

        dispatch({ type: "SET_ADDSECTION", payload: updatedSection });
      }
    } else if (shareTemplateData) {
      // share dashboard
      let traceName;
      filterData?.map((d) => {
        if (d?.attribute === value) {
          traceName = d?.title;
        }
      });
      let updatedBreakdown = [
        {
          ...widgetData?.y_axes?.[0],
          attribute: value,
          trace_name: traceName,
        },
      ];

      if (widgetData) {
        let updateShareTemplateData = { ...shareTemplateData };
        if (section_index >= 0) {
          updateShareTemplateData.sections[section_index].widgets[
            widget_index
          ].y_axes = updatedBreakdown;
          if (widgetData?.persist_graphdata) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].persist_graphdata = null;
          }

          if (widgetData?.deep_dive_on) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].deep_dive_on = null;
          }

          if (widgetData?.graphData) {
            updateShareTemplateData.sections[section_index].widgets[
              widget_index
            ].graphData = null;
          }
        } else {
          updateShareTemplateData.section[0].widgets[widget_index].y_axes =
            updatedBreakdown;
          if (widgetData?.persist_graphdata) {
            updateShareTemplateData.section[0].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (widgetData?.deep_dive_on) {
            updateShareTemplateData.section[0].widgets[
              widget_index
            ].deep_dive_on = null;
          }
          if (widgetData?.graphData) {
            updateShareTemplateData.section[0].widgets[widget_index].graphData =
              null;
          }
        }
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: updateShareTemplateData,
        });
      }
    } else {
      // view dashboard
      let traceName;
      filterData?.map((d) => {
        if (d?.attribute === value) {
          traceName = d?.title;
        }
      });
      let updatedBreakdown = [
        {
          ...widgetData?.y_axes?.[0],
          attribute: value,
          trace_name: traceName,
        },
      ];

      if (widgetData) {
        let updatePanes = [...panes];
        if (section_index >= 0) {
          updatePanes[index].sections[section_index].widgets[
            widget_index
          ].y_axes = updatedBreakdown;
          if (widgetData?.persist_graphdata) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (widgetData?.deep_dive_on) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].deep_dive_on = null;
          }
          if (widgetData?.graphData) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].graphData = null;
          }
        } else {
          updatePanes[index].section[0].widgets[widget_index].y_axes =
            updatedBreakdown;
          if (widgetData?.persist_graphdata) {
            updatePanes[index].section[0].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (widgetData?.deep_dive_on) {
            updatePanes[index].section[0].widgets[widget_index].deep_dive_on =
              null;
          }
          if (widgetData?.graphData) {
            updatePanes[index].section[0].widgets[widget_index].graphData =
              null;
          }
        }
        dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
      }
    }
  };

  return (
    <>
      <div className="d-flex align-items-center">
        <Select
          bordered={false}
          onChange={(e) =>
            handleChangeCategory(e, widgetData, section_index, widget_index)
          }
          popupClassName={
            authParams?.theme_type === "1"
              ? "darkTheme SingleBrands__dropdown--list"
              : "lightTheme SingleBrands__dropdown--list"
          }
          defaultValue={widgetData?.y_axes?.[0]?.attribute}
          value={widgetData?.y_axes?.[0]?.attribute}
          className={"border-radius-4 SingleBrands__dropdown--popup"}
          style={{ width: "100%" }}
          placement={"bottomRight"}
          dropdownMatchSelectWidth={false}
        >
          {widgetData?.widget_filters?.map((data) => {
            let displayValue;
            filterData?.map((d) => {
              if (d?.attribute === data) {
                displayValue = d?.title;
              }
            });
            return (
              <Option value={data} className="SingleBrands__dropdown--option ">
                {displayValue}
              </Option>
            );
          })}
        </Select>
      </div>
    </>
  );
};

export default CategoryOption;
